const a = "_compactStyle_7zjnd_1", d = "_drag_7zjnd_7", t = "_disabled_7zjnd_13", n = "_uploadContainer_7zjnd_17", o = {
  compactStyle: a,
  drag: d,
  disabled: t,
  uploadContainer: n
};
export {
  a as compactStyle,
  o as default,
  t as disabled,
  d as drag,
  n as uploadContainer
};
//# sourceMappingURL=NewFileUpload.module.scss.js.map
